import {formatDate} from '../../GenericTable/ColumnFilter'
function extractValues(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((item) =>
    typeof item === "string" ? item : item?.value ?? item?.label ?? String(item),
  );
}

export function mapFiltersToPayload(filters) {
  return {
    // facility: extractValues(filters.facility),
    speciality: extractValues(filters.speciality),
    coder: extractValues(filters.coder), 
    principal_diagnosis: extractValues(filters.principalDiagnosis),
    drg: extractValues(filters.drg),
    health_fund: extractValues(filters.healthFund),
    status: extractValues(filters.episodeStatus),
    admission_date_from: formatDate(filters.admissionFrom) || "",
    admission_date_to: formatDate(filters.admissionTo) || "",
    separation_date_from: formatDate(filters.separationFrom) || "",
    separation_date_to: formatDate(filters.separationTo) || "",
    episode_id: extractValues(filters.episodeId),
    audit_rule_category: extractValues(filters.auditRuleCategory),
    los_op: filters.losOp || "",
    los: filters.los || "",
    header_id: filters.header_id || [],
    financial_impact: filters.financialImpact || "",
  };
}
export function toInsightsPayload(filters) {
  const {
    financial_impact, 
    ...rest
  } = filters;
  return rest;
}
export function toSpecialityAuditPayload(filters, chartType = "pie", search = "") {
  const base = toInsightsPayload(filters);
  return {
    ...base,
    speciality: search ? [search] : base.speciality,
    is_global: !!search,
    chart_type: chartType,
  };
}
export function toFinancialImpactPayload(filters) {
  return toInsightsPayload(filters);
}
function mapPeriodToTimelineValue(period) {
  if (period === "Weekly") return "weekly";
  if (period === "Monthly") return "monthly";
  return ""; // Daily / default
}
export function toSpecialityAuditAnalysisPayload(
  filters,
  { sortBy = "", sortOrder = "asc", search = "" } = {},
) {
  const base = toInsightsPayload(filters);
  return {
    ...base,
    speciality: search ? [search] : base.speciality,
    is_global: !!search, // true only while actively searching
    sort_order: sortOrder,
    sort_by: sortBy,
  };
}
export function toFinancialImpactBySpecialityPayload(filters, { sortBy = "", sortOrder = "", page = 1, pageSize = 5 } = {}) {
  return {
    ...toInsightsPayload(filters),
    sort_by: sortBy,
    sort_order: sortOrder,
    page_number: page,
    page_size: pageSize,
  };
}
export function toCoderPerformanceMetricsPayload(filters, { sortBy = "", sortOrder = "" } = {}) {
  return {
    ...toInsightsPayload(filters),
    sort_by: sortBy,
    sort_order: sortOrder,
  };
}
export function toCodeChangesPayload(filters, { sortBy = "", sortOrder = "" } = {}) {
  return {
    ...toInsightsPayload(filters),
    sort_by: sortBy,
    sort_order: sortOrder,
  };
}

export function toDiagnosisTimelinePayload(filters, period = "Daily", { sortBy = "", sortOrder = "" } = {}) {
  return {
    ...toInsightsPayload(filters),
    diagnosis_changes_timeline: mapPeriodToTimelineValue(period),
    sort_by: sortBy,
    sort_order: sortOrder,
  };
}

export function toProcedureTimelinePayload(filters, period = "Daily", { sortBy = "", sortOrder = "" } = {}) {
  return {
    ...toInsightsPayload(filters),
    procedure_changes_timeline: mapPeriodToTimelineValue(period),
    sort_by: sortBy,
    sort_order: sortOrder,
  };
}
